<template>
  <div class="parent">
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
    ></title-widge>

    <div class="divCourse">
      <el-collapse v-model="activeName" accordion @change="handleChange">
        <el-collapse-item
          v-for="(item, index) in datas"
          :key="index"
          :title="item.title"
          :name="index"
        >
          <div class="divContent" v-for="(v, k) in item.details" :key="k">
            <div class="divDetail">
              <div class="divTitle">{{ v.title }}</div>
              <div class="divItem">
                <div
                  class="divDetail"
                  v-for="(item1, index1) in v.details"
                  :key="index1"
                >
                  {{ item1 }}
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="divStudy" @click="qimoChatClick">
      <img src="./../img/learn.png" />
      <span >马上学习</span>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";

export default {
  components: {
    titleWidge,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(7,46,124,1)",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  watch: {},
  data() {
    return {
      activeName: 0,
    };
  },
  methods: {
    handleChange(val) {
      this.$trackEvent(this.datas[val].title, "点击", this.datas[val].title)
    },
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击", "马上学习")
      window.qimoChatClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/courseWidge.scss";
</style>
<style lang="scss">
.parent {
  .divCourse {
    .el-collapse-item__arrow {
      position: static !important;
    }
    .el-collapse-item__arrow,
    .el-icon-arrow-right:before,
    .el-icon-caret-right,
    .el-icon-caret-right:before {
      content: "\e6e0" !important;
      background: none;
    }
    .el-collapse-item__header {
      font-size: 18px !important;
      font-family: PingFang SC;
      font-weight: 600;
      color: #072e7c;
      padding-left: 50px;
      height: 80px;
    }
  }
}
</style>
